<template>
  <v-app>
    <v-system-bar
      class="noprint"
      color="grey darken-2"
      dark
      height="40"
      app
      lights-out
    >
      <v-toolbar-items class="ml-5">
        <v-btn
          href="javascript:window.print()"
          class="title elevation-0 mr-2"
          color="grey darken-1"
          x-large
        >
          <v-icon>mdi-printer</v-icon>&nbsp; พิมพ์
        </v-btn>
        <v-btn
          @click.stop="Export2Doc('exportContent', 'word-content-1-4')"
          class="title elevation-0"
          color="grey darken-1"
          x-large
        >
          <v-icon>mdi-file-word</v-icon>&nbsp; Export to Word
        </v-btn>
        <v-btn
          @click.stop="exportToExcel('exportContent', 'รายงานผลการประเมิน')"
          class="mr-1"
          color="green"
        >
          <v-icon>mdi-file-excel</v-icon>&nbsp; Export to excel
        </v-btn>
      </v-toolbar-items>
    </v-system-bar>

    <div
      id="exportContent"
      style="mso-page-orientation: landscape; overflow-x: scroll; overflow-x: scroll;"
    >
      <div class="page">
        <div align="center">
          <div class="head">รายงานการประเมินครูผู้ช่วย</div>
          <div class="head">
            ข้อมูล ณ วันที่
            {{
              date_today_cal | moment("add", "543 year") | moment("D MMMM YYYY")
            }}
          </div>
          <table class="text_j table" width="100%">
            <thead class="th">
              <tr>
                <th rowspan="3" class="text-center th pa-1">ลำดับ</th>
                <th rowspan="3" class="text-center th pa-1">ประเภท</th>
                <th rowspan="3" class="text-center th pa-1">รหัสบัตรชาชน</th>
                <th rowspan="3" class="text-center th pa-1">ชื่อ-นามสกุล</th>
                <th rowspan="3" class="text-center th pa-1">ภาค</th>
                <th rowspan="3" class="text-center th pa-1">จังหวัด</th>
                <th rowspan="3" class="text-center th pa-1">วิทยาลัย</th>
                <th rowspan="3" class="text-center th pa-1">เลขที่ตำแหน่ง</th>
                <th rowspan="3" class="text-center th pa-1">คำสั่งที่</th>
                <th rowspan="3" class="text-center th pa-1">วันที่บรรจุ</th>

                <th colspan="10" class="text-center th pa-1">ปีที่ 1</th>
                <th colspan="10" class="text-center th pa-1">ปีที่ 2</th>
                <th rowspan="3" class="text-center th pa-1">
                  สรุปผล <br />
                  การประเมิน
                </th>

                <th rowspan="3" class="text-center th pa-1">
                  สถานะ <br />
                  ใบอนุญาต
                </th>

                <th rowspan="3" class="text-center th pa-1">
                  สถานะ <br />
                  คุรุสภา
                </th>



                <th colspan="5" class="text-center th pa-1">
                  ใบอนุญาตประกอบวิชาชีพ
                </th>

                <th rowspan="3" class="text-center th pa-1">สรุปวันลา</th>
                <th rowspan="3" class="text-center th pa-1">หมายเหตุ</th>
              </tr>
              <tr>
                <th colspan="5" class="text-center th pa-1">
                  ครั้งที่ 1
                </th>
                <th colspan="5" class="text-center th pa-1">
                  ครั้งที่ 2
                </th>
                <th colspan="5" class="text-center th pa-1">
                  ครั้งที่ 3
                </th>
                <th colspan="5" class="text-center th pa-1">
                  ครั้งที่ 4
                </th>

                <th rowspan="2" class="text-center th pa-1">
                  เลขที่
                </th>
                <th rowspan="2" class="text-center th pa-1">
                  ออกให้ ณ วันที่
                </th>
                <th rowspan="2" class="text-center th pa-1">
                  ให้ใช้จนถึงวันที่
                </th>
                <th rowspan="2" class="text-center th pa-1">
                  วันที่ได้รับแต่งตั้ง
                </th>

                <th rowspan="2" class="text-center th pa-1">
                  สถานะการตรวจ
                </th>
              </tr>
              <tr>
                <td class="text-center th pa-1">
                  ด้าน 1
                </td>
                <td class="text-center th pa-1">
                  ด้าน 2
                </td>
                <td class="text-center th pa-1">
                  รวม
                </td>
                <td class="text-center th pa-1">
                  ไฟล์
                </td>

                <td class="text-center th pa-1">
                  สถานะ
                </td>

                <td class="text-center th pa-1">
                  ด้าน 1
                </td>
                <td class="text-center th pa-1">
                  ด้าน 2
                </td>
                <td class="text-center th pa-1">
                  รวม
                </td>
                <td class="text-center th pa-1">
                  ไฟล์
                </td>
                <td class="text-center th pa-1">
                  สถานะ
                </td>

                <td class="text-center th pa-1">
                  ด้าน 1
                </td>
                <td class="text-center th pa-1">
                  ด้าน 2
                </td>
                <td class="text-center th pa-1">
                  รวม
                </td>
                <td class="text-center th pa-1">
                  ไฟล์
                </td>

                <td class="text-center th pa-1">
                  สถานะ
                </td>

                <td class="text-center th pa-1">
                  ด้าน 1
                </td>
                <td class="text-center th pa-1">
                  ด้าน 2
                </td>
                <td class="text-center th pa-1">
                  รวม
                </td>

                <td class="text-center th pa-1">
                  ไฟล์
                </td>
                <td class="text-center th pa-1">
                  สถานะ
                </td>
              </tr>
            </thead>
            <tbody
              class="td"
              v-for="(item, index) in assisPersonel"
              :key="item.id"
            >
              <tr>
                <td class="text-center th pa-1">{{ index + 1 }}</td>
                <td class="text-center th">
                  <div v-if="item.mt_type_personnel === 'local_dev'">
                    <v-chip color="info" dark>ครูพัฒนาท้องถิ่น</v-chip>
                  </div>
                  <div
                    v-else-if="item.mt_type_personnel === 'transfer_position'"
                  >
                    <v-chip color="warning" dark>ครูโอนย้าย</v-chip>
                  </div>
                  <div v-else>
                    <v-chip color="success" dark>ปกติ</v-chip>
                  </div>
                </td>
                <td class="text-center th pa-1">{{ item.mt_id_card }}</td>
                <td class="pl-1 th">
                  {{
                    item.mt_title_s +
                      item.mt_frist_name +
                      " " +
                      item.mt_last_name
                  }}
                </td>
                <td class="text-center th pa-1">{{ item.region_name }}</td>
                <td class="text-center th pa-1">{{ item.province_name }}</td>
                <td class="pl-1 th">{{ item.agency }}</td>
                <td class="text-center th pa-1">{{ item.mt_id_position }}</td>
                <td class="text-center th pa-1">{{ item.mt_order_app }}</td>
                <td class="text-center th pa-1">
                  {{
                    item.mt_date_app_now
                      | moment("add", "543 year")
                      | moment("D MMMM YYYY")
                  }}
                </td>

                <td class="text-center th pa-1">
                  <span v-if="item.mt_time_1_score_a > 0">
                    <div v-if="item.mt_time_1_score_a < 24" class="red--text">
                      {{ item.mt_time_1_score_a }}
                    </div>
                    <div v-else class="green--text">
                      {{ item.mt_time_1_score_a }}
                    </div>
                  </span>
                </td>
                <td class="text-center th pa-1">
                  <span v-if="item.mt_time_1_score_b > 0">
                    <div v-if="item.mt_time_1_score_b < 36" class="red--text">
                      {{ item.mt_time_1_score_b }}
                    </div>
                    <div v-else class="green--text">
                      {{ item.mt_time_1_score_b }}
                    </div>
                  </span>
                </td>
                <td class="text-center th pa-1">
                  <span v-if="item.mt_time_1_score > 0">
                    <div v-if="item.mt_time_1_score < 60" class="red--text">
                      {{ item.mt_time_1_score }}
                    </div>
                    <div v-else class="green--text">
                      {{ item.mt_time_1_score }}
                    </div>
                  </span>
                </td>

                <td class="text-center th pa-1">
                  <div v-if="String(item.mt_time_1_file).length > 4">
                    <v-btn
                      :href="
                        'http://hrvec.ovec.go.th/HRvecfiles/' +
                          item.mt_time_1_file
                      "
                      target="_blank"
                      color="info"
                      small
                      icon
                      ><v-icon>mdi-printer</v-icon></v-btn
                    >
                  </div>
                </td>

                <td class="text-center th pa-1">
                  <div
                    v-if="item.mt_time_1_ck === 'Pass'"
                    class="success--text"
                  >
                    ผ่าน
                  </div>

                  <div
                    v-else-if="item.mt_time_1_ck === 'NotPass'"
                    class="error--text"
                  >
                    ไม่ผ่าน
                  </div>

                  <div v-else class="warning--text">
                    ไม่ได้ตรวจ
                  </div>
                </td>

                <td class="text-center th pa-1">
                  <span v-if="item.mt_time_2_score_a > 0">
                    <div v-if="item.mt_time_2_score_a < 24" class="red--text">
                      {{ item.mt_time_2_score_a }}
                    </div>
                    <div v-else class="green--text">
                      {{ item.mt_time_2_score_a }}
                    </div>
                  </span>
                </td>
                <td class="text-center th pa-1">
                  <span v-if="item.mt_time_2_score_b > 0">
                    <div v-if="item.mt_time_2_score_b < 36" class="red--text">
                      {{ item.mt_time_2_score_b }}
                    </div>
                    <div v-else class="green--text">
                      {{ item.mt_time_2_score_b }}
                    </div>
                  </span>
                </td>
                <td class="text-center th pa-1">
                  <span v-if="item.mt_time_2_score > 0">
                    <div v-if="item.mt_time_2_score < 60" class="red--text">
                      {{ item.mt_time_2_score }}
                    </div>
                    <div v-else class="green--text">
                      {{ item.mt_time_2_score }}
                    </div>
                  </span>
                </td>

                <td class="text-center th pa-1">
                  <div v-if="String(item.mt_time_2_file).length > 4">
                    <v-btn
                      :href="
                        'http://hrvec.ovec.go.th/HRvecfiles/' +
                          item.mt_time_2_file
                      "
                      target="_blank"
                      color="info"
                      small
                      icon
                      ><v-icon>mdi-printer</v-icon></v-btn
                    >
                  </div>
                </td>

                <td class="text-center th pa-1">
                  <div
                    v-if="item.mt_time_2_ck === 'Pass'"
                    class="success--text"
                  >
                    ผ่าน
                  </div>

                  <div
                    v-else-if="item.mt_time_2_ck === 'NotPass'"
                    class="error--text"
                  >
                    ไม่ผ่าน
                  </div>

                  <div v-else class="warning--text">
                    ไม่ได้ตรวจ
                  </div>
                </td>

                <td class="text-center th pa-1">
                  <span v-if="item.mt_time_3_score_a > 0">
                    <div v-if="item.mt_time_3_score_a < 28" class="red--text">
                      {{ item.mt_time_3_score_a }}
                    </div>
                    <div v-else class="green--text">
                      {{ item.mt_time_3_score_a }}
                    </div>
                  </span>
                </td>

                <td class="text-center th pa-1">
                  <span v-if="item.mt_time_3_score_b > 0">
                    <div v-if="item.mt_time_3_score_b < 42" class="red--text">
                      {{ item.mt_time_3_score_b }}
                    </div>
                    <div v-else class="green--text">
                      {{ item.mt_time_3_score_b }}
                    </div>
                  </span>
                </td>
                <td class="text-center th pa-1">
                  <span v-if="item.mt_time_3_score > 0">
                    <div v-if="item.mt_time_3_score < 70" class="red--text">
                      {{ item.mt_time_3_score }}
                    </div>
                    <div v-else class="green--text">
                      {{ item.mt_time_3_score }}
                    </div>
                  </span>
                </td>

                <td class="text-center th pa-1">
                  <div v-if="String(item.mt_time_3_file).length > 4">
                    <v-btn
                      :href="
                        'http://hrvec.ovec.go.th/HRvecfiles/' +
                          item.mt_time_3_file
                      "
                      target="_blank"
                      color="info"
                      small
                      icon
                      ><v-icon>mdi-printer</v-icon></v-btn
                    >
                  </div>
                </td>

                <td class="text-center th pa-1">
                  <div
                    v-if="item.mt_time_3_ck === 'Pass'"
                    class="success--text"
                  >
                    ผ่าน
                  </div>

                  <div
                    v-else-if="item.mt_time_3_ck === 'NotPass'"
                    class="error--text"
                  >
                    ไม่ผ่าน
                  </div>

                  <div v-else class="warning--text">
                    ไม่ได้ตรวจ
                  </div>
                </td>

                <td class="text-center th pa-1">
                  <span v-if="item.mt_time_4_score_a > 0">
                    <div v-if="item.mt_time_4_score_a < 28" class="red--text">
                      {{ item.mt_time_4_score_a }}
                    </div>
                    <div v-else class="green--text">
                      {{ item.mt_time_4_score_a }}
                    </div>
                  </span>
                </td>

                <td class="text-center th pa-1">
                  <span v-if="item.mt_time_4_score_b > 0">
                    <div v-if="item.mt_time_4_score_b < 42" class="red--text">
                      {{ item.mt_time_4_score_b }}
                    </div>
                    <div v-else class="green--text">
                      {{ item.mt_time_4_score_b }}
                    </div>
                  </span>
                </td>

                <td class="text-center th pa-1">
                  <span v-if="item.mt_time_4_score > 0">
                    <div v-if="item.mt_time_4_score < 70" class="red--text">
                      {{ item.mt_time_4_score }}
                    </div>
                    <div v-else class="green--text">
                      {{ item.mt_time_4_score }}
                    </div>
                  </span>
                </td>

                <td class="text-center th pa-1">
                  <div v-if="String(item.mt_time_4_file).length > 4">
                    <v-btn
                      :href="
                        'http://hrvec.ovec.go.th/HRvecfiles/' +
                          item.mt_time_4_file
                      "
                      target="_blank"
                      color="info"
                      small
                      icon
                      ><v-icon>mdi-printer</v-icon></v-btn
                    >
                  </div>
                </td>

                <td class="text-center th pa-1">
                  <div
                    v-if="item.mt_time_4_ck === 'Pass'"
                    class="success--text"
                  >
                    ผ่าน
                  </div>

                  <div
                    v-else-if="item.mt_time_4_ck === 'NotPass'"
                    class="error--text"
                  >
                    ไม่ผ่าน
                  </div>

                  <div v-else class="warning--text">
                    ไม่ได้ตรวจ
                  </div>
                </td>

                <td class="text-center th pa-1">
                  {{
                    calAss(
                      item.mt_time_1_score,
                      item.mt_time_2_score,
                      item.mt_time_3_score,
                      item.mt_time_4_score
                    )
                  }}
                </td>

                <td class="text-center th pa-1">
                  <span :class="license_class(item.mt_license_status)">
                    {{ check_license_status(item.mt_license_status) }}
                  </span>
                </td>


                <td class="text-center th pa-1">
                  <span :class="license_ict_class(item.pt_licence_ict)">
                    {{ item.pt_licence_type || "" }} <br>
                    {{ check_license_ict_status(item.pt_licence_ict) }}
                  </span>
                </td>


                <td class="text-center th pa-1">
                  {{ item.pt_licence }}
                </td>

                <td class="text-center th pa-1">
                  {{
                    item.pt_ondate
                      | moment("add", "543 year")
                      | moment("D MMMM YYYY")
                  }}
                </td>
                <td class="text-center th pa-1">
                  {{
                    item.pt_enddate
                      | moment("add", "543 year")
                      | moment("D MMMM YYYY")
                  }}
                </td>

                <td class="text-center th pa-1">
                  {{
                    item.mt_date_app_now
                      | moment("add", "545 year")
                      | moment("D MMMM YYYY")
                  }}
                </td>

                <td class="text-center th pa-1">
                  <div v-if="item.pt_licence_file_ipa === 'pass'">
                    <v-icon color="success">mdi-check-circle</v-icon>
                    ผ่าน
                  </div>

                  <div
                    v-if="item.pt_licence_file_ipa === 'dontpass'"
                    class="red--text"
                  >
                    ไม่ผ่าน :
                    {{ item.pt_licence_file_ipacomment }}
                  </div>
                </td>

                <td class="text-center th pa-1">
                  {{ item.assistant_teacher_re_leaveday }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    ApiKey: "HRvec2021",
    user: [],
    assisPersonel: [],
    loading: true
  }),

  async mounted() {
    await this.sweetAlertLoading();
    await this.assisPersonelQuery();
    Swal.close();
  },

  methods: {
    check_license_status(license) {
      if (license === "have") {
        return "ใบประกอบวิชาชีพครู";
      } else if (license === "donot") {
        return "ใบอนุญาตปฏิบัติหน้าที่ครู (P License)";
      } 
      else if (license === "waitpl") {
        return "อยู่ระหว่างยื่นคำขอ (P License)";
      }
      else if (license === "anything") {
        return "ไม่มีใบอนุญาต(ใบอนุญาตควบคุม)";
      } else {
        return "ไม่ระบุ";
      }
    },

    check_license_ict_status(license) {
      if (license === "ict") {
        return "คุรุสภา";
      } else {
        return "";
      }
    },


    license_class(license) {
      if (license === "have") {
        return "success--text";
      } else if (license === "donot") {
        return "warning--text font-weight-bold";
      } 
      else if (license === "waitpl") {
        return "red--text font-weight-bold";
      }
      else if (license === "anything") {
        return "red--text font-weight-bold";
      } else {
        return "error--text";
      }
    },

      license_ict_class(license) {
      if (license === "ict") {
        return "success--text";
      } else {
        return "error--text";
      }
    },


    calAss(a, b, c, d) {
      let mt_time_1_score = parseFloat(a) || 0;
      let mt_time_2_score = parseFloat(b) || 0;
      let mt_time_3_score = parseFloat(c) || 0;
      let mt_time_4_score = parseFloat(d) || 0;

      let sum =
        (parseFloat(mt_time_1_score) +
          parseFloat(mt_time_2_score) +
          parseFloat(mt_time_3_score) +
          parseFloat(mt_time_4_score)) /
        4;
      let result;
      if (sum >= 70) {
        result = "ผ่านการประเมิน";
      }
      return result;
    },
    async assisPersonelQuery() {
      let mt_appoin_day = this.mt_appoin_day || this.appoin_day || 0;
      let mt_appoin_month = this.mt_appoin_month || this.appoin_month || 0;
      let mt_appoin_year = this.mt_appoin_year || this.appoin_year || 0;
      let dates = new Date(
        mt_appoin_year + "-" + mt_appoin_month + "-" + mt_appoin_day
      );
      let getTime = dates.getTime(); 

      if (getTime > 1) {
        let result = await this.$http
          .post("manage_assistant_teacher.score.php", {
            ApiKey: this.ApiKey,
            mt_appoin_day: mt_appoin_day,
            mt_appoin_month: mt_appoin_month,
            mt_appoin_year: mt_appoin_year,
            mt_type_personnel: this.mt_type_personnel,
            mt_admissions_status: this.mt_admissions_status
          })
          .finally(() => (this.loading = false));
        let datafilter = result.data;
        this.assisPersonel = result.data;
        //this.assisPersonel = datafilter.filter(value => String(value.user_code).length>4)
      }
    },

    async sweetAlertLoading() {
      Swal.fire({
        title: "Please Wait !",
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
        onBeforeOpen: () => {
          Swal.showLoading();
        },
        onAfterClose: () => {
          Swal.hideLoading();
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
    },

    Export2Doc(element, filename) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-16'><title>Export HTML To Doc</title></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword"
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-16," +
        encodeURIComponent(html);

      // Specify file name
      filename = filename ? filename + ".doc" : "document.doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
    exportToExcel(element, filename) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Excel</title></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msexcel"
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-excel;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      filename = filename ? filename + ".xls" : "document.xls";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }
      document.body.removeChild(downloadLink);
    }
  },
  computed: {
    appoin_day() {
      return this.$route.query.appoin_day;
    },
    appoin_month() {
      return this.$route.query.appoin_month;
    },
    appoin_year() {
      return this.$route.query.appoin_year;
    },

    mt_appoin_day() {
      return this.$route.query.mt_appoin_day;
    },
    mt_appoin_month() {
      return this.$route.query.mt_appoin_month;
    },
    mt_appoin_year() {
      return this.$route.query.mt_appoin_year;
    },

    mt_admissions_status() {
      return this.$route.query.mt_admissions_status;
    },
    mt_type_personnel() {
      return this.$route.query.mt_type_personnel;
    },

    date_today_cal() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = today.getFullYear();

      today = yyyy + "-" + mm + "-" + dd;
      return today;
    }
  },
  props: {
    source: String
  }
};
</script>
<style>
body {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16px;
  font-weight: 250;
}

.u {
  border-bottom: 1px dotted #000;
  text-decoration: none;
}
u {
  border-bottom: 1px dotted #000;
  text-decoration: none;
}

* {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.table,
.th,
.td {
  border-bottom: 0.5px solid black;
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-collapse: collapse;
}

.text_j {
  border-collapse: collapse;
  text-align: justify;
  text-justify: inter-word;
  line-height: 1;
}
.text_l {
  border-collapse: collapse;
  text-align: left;
  text-justify: inter-word;
  line-height: 1;
}

tfoot tr:hover {
  background-color: initial;
}

tbody tr:hover {
  background-color: inherit;
}

td,
th {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
}

tfoot td {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-weight: bold;
}

#verticaltext {
  writing-mode: tb-rl;
  filter: flipv fliph;
  -webkit-transform: rotate(-90deg);
  white-space: nowrap;
  display: block;
  overflow: hidden;
  padding: 0;
}

.page {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
  width: auto;
  min-height: 29.7cm;
  border: 1px #d3d3d3 solid;
  border-radius: 5px;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  margin-top: 0cm;
  margin-right: auto;
  margin-bottom: 0cm;
  margin-left: auto;
  padding-top: 1.5cm;
  padding-right: 1cm;
  padding-bottom: 1.5cm;
  padding-left: 1cm;
}

.head {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 22pt;
  font-weight: bold;
  line-height: 1;
}

.regular12 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 14pt;
}

.regular16 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
}

.bold16 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
  font-weight: bold;
}

.blod12 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 14pt;
  font-weight: bold;
}

.blackRegula10 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 12pt;
}

.blackBold18 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 18pt;
  font-weight: bold;
}

.largerCheckbox {
  width: 30px;
  height: 30px;
  color: blue;
}
.td_line {
  border-bottom: 1pt dotted black;
}
/*.subpage {
            height: 247mm;
          }*/

.BlackBold10 {
  font-weight: bold;
}

#content {
  display: table;
}

#pageFooter {
  display: table-footer-group;
}

#pageFooter:after {
  counter-increment: page;
  content: counter(page);
}

@media print {
  .page {
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    padding: initial;
    page-break-after: always;
  }

  .head {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 18pt;
    font-weight: bold;
  }

  .regular12 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
  }

  .regular16 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
  }

  .bold16 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
    font-weight: bold;
  }

  .blod12 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
    font-weight: bold;
  }

  .blackRegula10 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 14pt;
  }

  .blackBold18 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 18pt;
    font-weight: bold;
  }

  /* .head {
              font-size: 18px;
              font-weight: bold;
            }
            .regular12 {
              font-size: 12px;
            }
            .blod12 {
              font-size: 12px;
              font-weight: bold;
            }
            .blackRegula8 {
              font-size: 8px;
            } */
  .noprint {
    display: none;
  }

  .gap-10 {
    width: 100%;
    height: 10px;
  }
  .gap-20 {
    width: 100%;
    height: 20px;
  }
  .gap-30 {
    width: 100%;
    height: 30px;
  }
}
</style>
